import type { CompareInfluencer } from "@/contexts/CompareContext";

export function toCompareInfluencer(data: any): CompareInfluencer {
  return {
    id: data.id,
    name: data.name,
    primary_handle: data.handle ? data.handle.replace("@", "") : "",
    profile_pic_path: data.profilePic,
    total_followers_count: data.rawFollowersCount,
    avg_engagement_rate: data.rawEngagementRate,
    tier: data.tier?.toLowerCase(),
    city: data.rawCity,
    country: data.rawCountry,
    categories: data.rawCategories,
    platforms: data.rawPlatforms,
    quality_score: data.qualityScore,
  };
}
